module.exports = __webpack_public_path__ + "static/img/suppliers-img.b8eed91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suppliers-img.jpg
// module id = XdwT
// module chunks = 1